import { ReactNode } from "react";
import I18n from "common/i18n";
import { useBuilderSidebar } from "./BuilderSidebar";

// 左サイドバーの見出し付きセクション（アイコン+ラベル+区切り線）
export const SidebarSection = ({
  icon,
  labelKey,
  accentClass,
  divider = true,
  children,
}: {
  icon: string;
  labelKey: string;
  accentClass: string;
  divider?: boolean;
  children: ReactNode;
}) => {
  const { collapsed } = useBuilderSidebar();

  // 折りたたみ時は見出し・区切り線を出さず、中身（アイコン化されたボタン）だけ縦に並べる
  if (collapsed) {
    return <div className="flex-col-el items-center w-full gap-2 py-2">{children}</div>;
  }

  return (
    <div
      className={`flex-col-el items-start w-full gap-2 px-3 py-3 ${
        divider ? "border-0 border-b-2 border-solid border-beige-60" : ""
      }`}
    >
      <div className="flex-row-el items-center gap-1">
        <span className={`material-symbols-outlined type-md ${accentClass}`}>{icon}</span>
        <p className="type-text type-sm text-textcolor-black">{I18n.t(labelKey)}</p>
      </div>
      {children}
    </div>
  );
};
